export default __webpack_public_path__ + "static/media/lily.00f9df86.png";